<template>
  <b-form class="col-md-12 px-0 page-section pt-0" @submit.prevent="onSubmit">
    <h2 class="text-center mb-1">Welcome</h2>
    <p class="text-center mb-5 std-onboarding-subtitle">
      Welcome! We’re excited to help you navigate your career. Let's setup your account details!
    </p>
    <!-- <b-form-group
      :label="$t('userMsgs.avatar')"
      description="This will be your profile photo. Ensure there is good lighting and that no other people or objects are in the photo."
      label-for="avatar"
      label-class="form-label"
      class="row-align-items-center"
    >
      <b-media class="align-items-center" vertical-align="center">
        <user-avatar
          slot="aside"
          size="lg"
          :isLoading="isUploading.avatar"
          :user="user"
          url-field="avatar_url"
          first-name-field="first_name"
          last-name-field="last_name"
          variant="dark"
        >
        </user-avatar>

        <b-form-file
          id="avatar"
          placeholder="Select professional looking headshot photo (max size: 10MB)."
          :browse-text="$t('generalMsgs.browse')"
          v-model="selectedUploadFile.avatar"
          @input="uploadFile('avatar', 'images')"
          :disabled="isUploading.avatar"
          accept="image/*"
          :state="fileSizeExceed.avatar || invalidFileType.avatar ? false : null"
        />
        <b-form-invalid-feedback v-if="fileSizeExceed.avatar"
          >File size exceeded. Please make sure the file is under 10MB.</b-form-invalid-feedback
        >
        <b-form-invalid-feedback v-else-if="invalidFileType.avatar"
          >Invalid file type. Please select an image.</b-form-invalid-feedback
        >
      </b-media>
    </b-form-group> -->

    <div class="row">
      <b-form-group label-for="firstname" label-class="form-label" class="col-md-6">
        <template #label> First Name <span style="color: red">*</span> </template>
        <b-form-input
          id="firstname"
          :placeholder="$t('userMsgs.firstName')"
          v-model="user.first_name"
          required
          :state="!$v.user.first_name.required && $v.user.first_name.$dirty ? false : null"
        />

        <b-form-invalid-feedback>This field is required.</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label-for="lastname" label-class="form-label" class="col-md-6">
        <template #label> Last Name <span style="color: red">*</span> </template>
        <b-form-input
          id="lastname"
          :placeholder="$t('userMsgs.lastName')"
          v-model="user.last_name"
          required
          :state="!$v.user.last_name.required && $v.user.last_name.$dirty ? false : null"
        />
        <b-form-invalid-feedback>This field is required.</b-form-invalid-feedback>
      </b-form-group>
    </div>

    <div class="row">
      <b-form-group label-for="npass" label-class="form-label" class="col-md-6">
        <template #label> New Password <span style="color: red">*</span> </template>
        <b-form-input
          id="npass"
          name="password"
          :placeholder="$t('authMsgs.newPassword')"
          v-model="user.password"
          :required="!!user.repeatPassword"
          :type="fieldTypes.password"
          autocomplete="off"
          @focus="handlePassType"
          @blur="handlePassType"
          :state="
            (!$v.user.password.required || !$v.user.password.isCorrectFormat) && $v.user.password.$dirty ? false : null
          "
        />
        <b-form-invalid-feedback v-if="!$v.user.password.required">This field is required.</b-form-invalid-feedback>
        <b-form-invalid-feedback v-else>{{ $t(`passValidationMsgs.${passErrorCode}`) }}</b-form-invalid-feedback>
        <password-strength-meter :password="user.password" />
      </b-form-group>

      <b-form-group label-for="repeatPassword" label-class="form-label" class="col-md-6">
        <template #label> Repeat Password <span style="color: red">*</span> </template>
        <b-form-input
          id="repeatPassword"
          name="repeatPassword"
          :placeholder="$t('profileMsgs.repeatPassword')"
          v-model="user.repeatPassword"
          :required="!!user.password"
          :type="fieldTypes.repeatPassword"
          autocomplete="off"
          @focus="handlePassType"
          @blur="handlePassType"
          :state="
            (!$v.user.repeatPassword.required || !$v.user.repeatPassword.isCorrectFormat) &&
            $v.user.repeatPassword.$dirty
              ? false
              : null
          "
        />
        <b-form-invalid-feedback v-if="!$v.user.repeatPassword.required"
          >This field is required.</b-form-invalid-feedback
        >
        <b-form-invalid-feedback v-else>{{ $t(`passValidationMsgs.${repPassErrorCode}`) }}</b-form-invalid-feedback>
      </b-form-group>
    </div>
    <b-form-group label-for="email" label-class="form-label" v-if="$route.name === 'accept-invite'">
      <template #label> Email Address <span style="color: red">*</span> </template>
      <b-form-input
        id="email"
        :placeholder="$t('authMsgs.emailAddr')"
        :value="getInviteData.email"
        disabled
        type="email"
      />
    </b-form-group>

    <b-form-group label-for="phone" label-class="form-label">
      <template #label> Phone <span style="color: red">*</span> </template>
      <b-form-input
        id="phone"
        placeholder="(888) 689 - 1235"
        v-model="user.phone"
        v-mask="'(###) ### - ####'"
        :state="(!$v.user.phone.required || !$v.user.phone.isCorrectFormat) && $v.user.phone.$dirty ? false : null"
      />
      <b-form-invalid-feedback v-if="!$v.user.phone.required">This field is required.</b-form-invalid-feedback>
      <b-form-invalid-feedback v-else>
        Invalid phone number. Please make sure that it's in correct format i.e. (XXX) XXX - XXXX.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label-for="gender" label-class="form-label">
      <template #label> Gender <span style="color: red">*</span> </template>
      <v-select
        id="gender"
        class="form-control v-select-custom"
        :class="!$v.user.gender.required && $v.user.gender.$dirty ? 'form-control is-invalid' : ''"
        label="text"
        v-model="user.gender"
        :reduce="item => item.value"
        placeholder="Select Your Gender"
        :options="genderOptions"
      >
        <template #search="{ attributes, events }">
          <input class="vs__search" :required="!user.gender" v-bind="attributes" v-on="events" />
        </template>
      </v-select>
      <b-form-invalid-feedback :state="!$v.user.gender.required && $v.user.gender.$dirty ? false : null"
        >This field is required.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Enrolled Program" label-for="enrolled_program" label-class="form-label">
      <template v-if="getLoggedInUserDashboard === DASHBOARD_TYPES.SCHOOL" #label>
        Enrolled Program <span style="color: red">*</span>
      </template>
      <v-select
        id="enrolled_program"
        class="form-control v-select-custom"
        :class="
          !$v.profile.enrolled_program.required && $v.profile.enrolled_program.$dirty ? 'form-control is-invalid' : ''
        "
        label="title"
        v-model="profile.enrolled_program"
        :reduce="enrolled_program => enrolled_program.id"
        placeholder="Select Enrolled Program"
        :loading="areProgramsLoading"
        :options="allPrograms"
        :disabled="isInviteFieldPreselected('enrolled_program')"
      >
        <template #search="{ attributes, events }">
          <input class="vs__search" :required="!profile.enrolled_program" v-bind="attributes" v-on="events" />
        </template>
        <template slot="option" slot-scope="option">
          <span>{{ option.title }}</span>
        </template>
      </v-select>
      <b-form-invalid-feedback
        :state="!$v.profile.enrolled_program.required && $v.profile.enrolled_program.$dirty ? false : null"
        >This field is required.</b-form-invalid-feedback
      >
    </b-form-group>
    <b-form-group
      v-if="(getLoggedInUserDashboard === DASHBOARD_TYPES.SCHOOL || isInviteAcceptance) && !isEdit"
      label="Enrolled Course"
      label-for="assigned_course"
      label-class="form-label"
    >
      <v-select
        id="assigned_course"
        class="form-control v-select-custom"
        label="title"
        v-model="profile.assigned_course"
        :reduce="assigned_course => assigned_course.id"
        placeholder="Select Enrolled Course"
        :loading="areCoursesLoading"
        :options="allCourses"
        :disabled="true"
      >
        <template slot="option" slot-scope="option">
          <span>{{ option.title }}</span>
        </template>
      </v-select>
    </b-form-group>
    <b-form-group
      v-if="getLoggedInUserDashboard === DASHBOARD_TYPES.ORGANIZATION"
      label="School"
      label-for="school"
      label-class="form-label"
    >
      <template #label> School <span style="color: red">*</span> </template>
      <v-select
        id="school"
        class="form-control v-select-custom"
        label="title"
        v-model="profile.static_school"
        :reduce="school => school.value"
        placeholder="Select School"
        :loading="areSchoolsLoading"
        :options="allSchools"
        :disabled="disabledSchoolSelect"
      >
        <template slot="option" slot-scope="option">
          <span>{{ option.title }}</span>
        </template>
      </v-select>
      <b-form-invalid-feedback
        :state="!$v.profile.static_school.required && $v.profile.static_school.$dirty ? false : null"
        >This field is required.</b-form-invalid-feedback
      >
    </b-form-group>
    <b-form-group
      v-if="getLoggedInUserDashboard === DASHBOARD_TYPES.SCHOOL || isInviteAcceptance"
      label="Tag"
      label-for="tag"
      label-class="form-label"
    >
      <v-select
        id="tag"
        class="form-control v-select-custom"
        label="title"
        v-model="profile.selected_tag"
        :value="profile.selected_tag"
        :reduce="tag => tag.id"
        placeholder="Select Tag"
        :options="tagOptions"
        :loading="isTagsLoading && !tagOptions.length"
        :disabled="true"
      >
        <template slot="option" slot-scope="option">
          <span>{{ option.title }}</span>
        </template>
        <template slot="selected-option" slot-scope="option">
          {{ option.title }}
        </template>
      </v-select>
    </b-form-group>
    <!-- <b-form-group label-for="program_type" label-class="form-label">
      <template #label> Program Type <span style="color: red">*</span> </template>

      <v-select
        id="program_type"
        class="form-control v-select-custom"
        label="text"
        v-model="profile.program_type"
        :reduce="p => p.value"
        placeholder="Select Program Type"
        :options="programTypeOptions"
        :class="!$v.profile.program_type.required && $v.profile.program_type.$dirty ? 'form-control is-invalid' : ''"
      >
      </v-select>
      <b-form-invalid-feedback
        :state="!$v.profile.program_type.required && $v.profile.program_type.$dirty ? false : null"
        >This field is required.</b-form-invalid-feedback
      >
    </b-form-group> -->

    <!-- <b-form-group label-for="prog_weeks" label-class="form-label">
      <template #label> Approx. Program Weeks <span style="color: red">*</span> </template>

      <b-form-input
        id="prog_weeks"
        placeholder="Enter Approx. Program Weeks"
        type="number"
        min="1"
        v-model="profile.prog_weeks"
        :state="
          (!$v.profile.prog_weeks.minValue || !$v.profile.prog_weeks.required) && $v.profile.prog_weeks.$dirty
            ? false
            : null
        "
      />
      <b-form-invalid-feedback v-if="!$v.profile.prog_weeks.minValue"
        >Must be greater or equal to 1.</b-form-invalid-feedback
      >
      <b-form-invalid-feedback v-else-if="!$v.profile.prog_weeks.required"
        >This field is required.</b-form-invalid-feedback
      >
    </b-form-group> -->

    <b-form-group label="Start Date" label-for="start_date" label-class="form-label">
      <template #label v-if="getLoggedInUserDashboard === DASHBOARD_TYPES.SCHOOL">
        Start Date <span style="color: red">*</span>
      </template>
      <date-picker
        v-model="profile.start_date"
        type="date"
        format="MM/DD/YYYY"
        value-type="YYYY-MM-DD"
        style="width: 100%"
        lang="en"
        placeholder="MM/DD/YYYY"
        id="start_date"
        :input-class="
          `mx-input ${!$v.profile.start_date.required && $v.profile.start_date.$dirty ? 'form-control is-invalid' : ''}`
        "
      ></date-picker>
      <b-form-invalid-feedback :state="!$v.profile.start_date.required && $v.profile.start_date.$dirty ? false : null"
        >This field is required.</b-form-invalid-feedback
      >
    </b-form-group>
    <b-form-group label="Expected Completion Date" label-for="gradDate" label-class="form-label">
      <template v-if="getLoggedInUserDashboard === DASHBOARD_TYPES.SCHOOL" #label>
        Expected Completion Date <span style="color: red">*</span>
      </template>
      <date-picker
        v-model="profile.grad_date"
        type="month"
        format="MMMM, YYYY"
        style="width: 100%"
        value-type="date"
        id="grad_date"
        lang="en"
        placeholder="No Date Selected"
        class="w-100"
        :input-class="
          `mx-input ${!$v.profile.grad_date.required && $v.profile.grad_date.$dirty ? 'form-control is-invalid' : ''}`
        "
      ></date-picker>
      <b-form-invalid-feedback :state="!$v.profile.grad_date.required && $v.profile.grad_date.$dirty ? false : null"
        >This field is required.</b-form-invalid-feedback
      >
    </b-form-group>
    <p class="mb-3 mt-0" style="font-style: italic;">
      Note: Your completion date is the day that you have completed your last day of training and received your
      Certificate of Completion.
    </p>
    <b-form-group label="CNA License Number" label-for="cnaLicenseNo" label-class="form-label">
      <b-form-input
        id="cnaLicenseNo"
        placeholder="CNXXXXXXXXXX (leave blank if not received)"
        v-model="profile.cna_license_no"
        v-mask="'CN##########'"
        :state="!$v.profile.cna_license_no.isCorrectFormat && $v.profile.cna_license_no.$dirty ? false : null"
      />
      <b-form-invalid-feedback
        >Invalid number. Please make sure that it's in correct format i.e. CNXXXXXXXXXX.</b-form-invalid-feedback
      >
    </b-form-group>
    <b-form-group label="CMA License Number" label-for="cmaLicenseNo" label-class="form-label">
      <b-form-input id="cmaLicenseNo" placeholder="Enter CMA License Number" v-model="profile.cma_license_no" />
    </b-form-group>
    <b-form-group :label="$t('studentMsgs.quote')" label-for="quote" label-class="form-label">
      <b-form-input
        id="quote"
        :placeholder="$t('studentMsgs.quotePlaceholder')"
        v-model="profile.quote"
        maxlength="70"
      />
    </b-form-group>

    <b-form-group :label="$t('userMsgs.bio')" label-for="about" label-class="form-label">
      <b-form-textarea id="about" :placeholder="`${$t('studentMsgs.bioPlaceholder')}`" :rows="5" v-model="user.bio" />
    </b-form-group>

    <!-- Address Fields -->
    <h5>Home Address</h5>
    <h6>Your address won't be shown to employers. We use your address to match you up with jobs in your area.</h6>

    <b-form-group label-for="address" label-class="form-label">
      <template #label> Street Address <span style="color: red">*</span> </template>
      <b-form-input
        id="address"
        placeholder="Street Address"
        v-model="profile.address"
        :state="!$v.profile.address.required && $v.profile.address.$dirty ? false : null"
      />
      <b-form-invalid-feedback>This field is required.</b-form-invalid-feedback>
    </b-form-group>

    <div class="row">
      <b-form-group label-for="zipcode" label-class="form-label" class="col-md-6">
        <template #label> Zipcode <span style="color: red">*</span> </template>
        <b-form-input
          id="zipcode"
          :placeholder="$t('addressMsgs.zipcode')"
          v-model="profile.zipcode"
          :state="!$v.profile.zipcode.required && $v.profile.zipcode.$dirty ? false : null"
        />
        <b-form-invalid-feedback>This field is required.</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group :label="$t('addressMsgs.city')" label-for="city" label-class="form-label" class="col-md-6">
        <template #label> City <span style="color: red">*</span> </template>
        <b-form-input
          id="city"
          :placeholder="$t('addressMsgs.city')"
          v-model="profile.city"
          :state="!$v.profile.city.required && $v.profile.city.$dirty ? false : null"
        />
        <b-form-invalid-feedback>This field is required.</b-form-invalid-feedback>
      </b-form-group>
    </div>

    <div class="row">
      <b-form-group label-for="state" label-class="form-label" class="col-md-6">
        <template #label> State <span style="color: red">*</span> </template>
        <v-select
          id="state"
          class="form-control v-select-custom"
          label="text"
          v-model="profile.state"
          :state="!$v.profile.state.required && $v.profile.state.$dirty ? false : null"
          :reduce="state => state.value"
          placeholder="Select State"
          :options="stateOptions"
        >
          <template #search="{ attributes, events }">
            <input class="vs__search" :required="!profile.state" v-bind="attributes" v-on="events" />
          </template>
        </v-select>
        <b-form-invalid-feedback>This field is required.</b-form-invalid-feedback>
      </b-form-group>

      <b-form-group label-for="country" label-class="form-label" class="col-md-6">
        <template #label> Country <span style="color: red">*</span> </template>
        <v-select
          id="country"
          disabled
          class="form-control v-select-custom"
          :class="!$v.profile.country.required && $v.profile.country.$dirty ? 'form-control is-invalid' : ''"
          label="text"
          v-model="profile.country"
          :reduce="country => country.value"
          :placeholder="$t('addressMsgs.countryPlaceholder')"
          :options="countryOptions"
          :clearable="false"
        >
          <template #search="{ attributes, events }">
            <input class="vs__search" :required="!profile.country" v-bind="attributes" v-on="events" />
          </template>
        </v-select>
        <b-form-invalid-feedback :state="!$v.profile.country.required && $v.profile.country.$dirty ? false : null"
          >This field is required.</b-form-invalid-feedback
        >
      </b-form-group>
    </div>
  </b-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import axios from 'axios';
import { map, pick } from 'lodash';
import { countries } from 'countries-list';
import { CNA_LICENSE_NUM_REGEX } from '../../../../common/constants';
import DatePicker from 'vue2-datepicker';
import PasswordStrengthMeter from '@/components/Ui/PasswordStrengthMeter.vue';
import { get } from 'lodash';
// import UserAvatar from '../../../../components/User/UserAvatar.vue';
import {
  PASSWORD_ALL_NUMERIC_REGEX,
  PASSWORD_COMPLEXITY_REGEX,
  PASSWORD_MIN_LENGTH,
  PASSWORD_VALIDATIONS,
  PHONE_FORMAT_REGEX,
  // PROGRAM_TYPE_OPTIONS,
  DASHBOARD_TYPES,
} from '../../../../common/constants';
var UsaStates = require('usa-states').UsaStates;

export default {
  components: { DatePicker, PasswordStrengthMeter },

  props: {
    userData: { type: Object, required: true },
    profileData: { type: Object, required: true },
    schoolName: { type: String, required: true },
    allPrograms: { type: Array, default: () => [] },
    areProgramsLoading: { type: Boolean, default: false },
    allTagsData: { type: Array, default: () => [] },
    areTagsLoadingData: { type: Boolean, default: false }
  },

  data() {
    return {
      user: {
        first_name: '',
        last_name: '',
        password: '',
        repeatPassword: '',
        phone: '',
        gender: '',
        bio: '',
        //  avatar_url: '',
      },
      profile: {
        grad_date: null,
        quote: '',
        address: '',
        zipcode: '',
        city: '',
        state: '',
        start_date: null,
        country: 'United States',
        enrolled_program: null,
        assigned_course: null,
        // prog_weeks: null,
        cna_license_no: null,
        cma_license_no: null,
        // program_type: '',
        selected_tag: null,
        static_school: null,
      },
      isEdit: false,
      disabledSchoolSelect: false,
      countryOptions: [],
      stateOptions: [],
      // programTypeOptions: PROGRAM_TYPE_OPTIONS,
      genderOptions: [
        { value: 'male', text: 'Male' },
        { value: 'female', text: 'Female' },
        { value: 'other', text: 'Other' },
      ],

      isUploading: { avatar: false },
      selectedUploadFile: { avatar: null },
      uploadPercent: { avatar: 0 },
      uploadCancelTokenSource: { avatar: null },
      fileSizeExceed: { avatar: false },
      invalidFileType: { avatar: false },
      areCoursesLoading: false,
      errorStates: { password: null, phone: null },
      passErrorCode: null,
      repPassErrorCode: null,

      fieldTypes: { password: 'text', repeatPassword: 'text' },

      allTags: [],
      areTagsLoading: false,
      limit: 15,
      offset: 0,
      totalTags: 0,
      search: '',
      DASHBOARD_TYPES,
      allSchools: [],
      areSchoolsLoading: false,
      allCourses: [],
    };
  },

  validations() {
    return {
      user: {
        first_name: { required },
        last_name: { required },
        password: {
          required,
          isCorrectFormat(value) {
            if (value.length < PASSWORD_MIN_LENGTH) {
              this.passErrorCode = PASSWORD_VALIDATIONS.PASSWORDS_MIN_LENGTH;
              return false;
            } else if (PASSWORD_ALL_NUMERIC_REGEX.test(value)) {
              this.passErrorCode = PASSWORD_VALIDATIONS.PASSWORDS_ALL_NUMERIC;
              return false;
            } else if (!PASSWORD_COMPLEXITY_REGEX.test(value)) {
              this.passErrorCode = PASSWORD_VALIDATIONS.PASSWORDS_NO_COMPLEXITY;
              return false;
            } else if (value !== this.user.repeatPassword) {
              this.passErrorCode = PASSWORD_VALIDATIONS.PASSWORDS_NOT_MATCH;
              return false;
            }
            return true;
          },
        },
        repeatPassword: {
          required,
          isCorrectFormat() {
            if (this.user.password !== this.user.repeatPassword) {
              this.repPassErrorCode = PASSWORD_VALIDATIONS.PASSWORDS_NOT_MATCH;
              return false;
            }
            return true;
          },
        },
        phone: {
          required,
          isCorrectFormat(value) {
            return PHONE_FORMAT_REGEX.test(value);
          },
        },
        gender: { required },
        bio: {},
        // avatar_url: {
        //   validFile() {
        //     return !this.fileSizeExceed.avatar && !this.invalidFileType.avatar;
        //   },
        // },
      },
      profile: {
        grad_date: { required: requiredIf(() => this.getLoggedInUserDashboard === DASHBOARD_TYPES.SCHOOL) },
        quote: {},
        address: { required },
        zipcode: { required },
        city: { required },
        state: { required },
        country: { required },
        enrolled_program: { required: requiredIf(() => this.getLoggedInUserDashboard === DASHBOARD_TYPES.SCHOOL) },
        selected_tag: {},
        // prog_weeks: {
        //   required: requiredIf(() => this.getLoggedInUserDashboard === DASHBOARD_TYPES.SCHOOL),
        //   minValue: minValue(1),
        // },
        start_date: { required: requiredIf(() => this.getLoggedInUserDashboard === DASHBOARD_TYPES.SCHOOL) },
        // program_type: { required: requiredIf(() => this.getLoggedInUserDashboard === DASHBOARD_TYPES.SCHOOL) },

        cna_license_no: {
          isCorrectFormat(value) {
            return !value || CNA_LICENSE_NUM_REGEX.test(value);
          },
        },
        static_school: { required: requiredIf(() => this.getLoggedInUserDashboard === DASHBOARD_TYPES.ORGANIZATION) },
      },
    };
  },

  computed: {
    ...mapGetters('invite', ['getInviteData']),
    ...mapGetters('auth', ['getLoggedInUserDashboard', 'getLoggedInUser', 'isLoggedIn']),
    isInviteAcceptance() {
      return this.$route.name === 'accept-invite';
    },
    tagOptions() {
      const options = [...this.allTagsData];
      this.allTags.forEach(tag => {
        if (!options.some(option => option.id === tag.id)) {
          options.push(tag);
        }
      });

      const selectedTag = this.getInviteFieldObject('selected_tag');
      if (selectedTag && !options.some(tag => tag.id === selectedTag.id)) {
        return [selectedTag, ...options];
      }
      return options;
    },
    isTagsLoading() {
      return this.areTagsLoading || this.areTagsLoadingData;
    },
  },

  watch: {
    userData: {
      handler() {
        this.user = { ...this.userData };
      },
      deep: true,
    },
    profileData: {
      handler() {
        this.profile = pick(this.profileData, [
          'grad_date',
          'quote',
          'address',
          'zipcode',
          'city',
          'state',
          'country',
          'enrolled_program',
          'start_date',
          'cna_license_no',
          'cma_license_no',
          // 'program_type',
          'selected_tag',
          'static_school',
          'assigned_course',
        ]);
        this.disabledSchoolSelect = !!this.profile.static_school;
        this.isEdit = get(this.profile, 'assigned_course.id') ? true : false;
      },
      deep: true,
    },
    'profile.enrolled_program': {
      handler(newVal, oldVal) {
        this.fetchCourses();
        this.offset = 0;
        this.search = '';
        this.allTags = [];
        // Only clear the tag when the user actually switches programs. This
        // watcher also fires when the fetched profile first populates the form
        // (oldVal is empty), and clearing there wiped the student's existing
        // tag on onboarding completion since the tag select is disabled.
        if (oldVal && !this.isInviteFieldPreselected('selected_tag')) {
          this.profile.selected_tag = null;
        }
        this.fetchTags();
      },
    },
  },

  methods: {
    ...mapActions('student', ['getMyStudentProfile', 'updateMyStudentProfile', 'getStudentUploadPresignedUrl']),
    ...mapActions('s3Upload', ['uploadToPresignedUrl']),
    ...mapActions('attendance', ['getTags']),
    ...mapActions('school', ['getAllSchools']),
    ...mapActions('courses', ['getProgramCourses']),

    getInviteFieldId(fieldName) {
      const value = get(this.getInviteData, fieldName, null);
      return get(value, 'id', value);
    },

    getInviteFieldObject(fieldName) {
      const value = get(this.getInviteData, fieldName, null);
      return value && typeof value === 'object' ? value : null;
    },

    isInviteFieldPreselected(fieldName) {
      return this.isInviteAcceptance && !!this.getInviteFieldId(fieldName);
    },

    addInviteSelectionsToOptions() {
      const assignedCourse = this.getInviteFieldObject('assigned_course');
      if (assignedCourse && !this.allCourses.some(course => course.id === assignedCourse.id)) {
        this.allCourses = [assignedCourse, ...this.allCourses];
      }
    },

    normalizeTagResponse(response) {
      return get(response, 'data.data.results') || get(response, 'data.data') || get(response, 'data') || [];
    },

    async fetchTags() {
      // The tags endpoint requires an authenticated school/student session, so
      // it can only be called once the student is signed in. On the public
      // accept-invite page the tag pre-selected on the invite is all we have.
      if (!this.profile.enrolled_program || !this.isLoggedIn) {
        this.allTags = [];
        return;
      }

      this.areTagsLoading = true;
      try {
        const response = await this.getTags({
          program__id: this.profile.enrolled_program,
          limit: this.limit,
          offset: 0,
        });
        this.allTags = this.normalizeTagResponse(response);
      } catch (err) {
        this.allTags = [];
      }
      this.areTagsLoading = false;
    },

    async fetchCourses() {
      if (!this.profile.enrolled_program) {
        this.allCourses = [];
        return;
      }

      this.areCoursesLoading = true;
      try {
        const school_id = get(this.getLoggedInUser, 'linked_entity.id') || get(this.getInviteData, 'linked_entity_id');
        const resp = await this.getProgramCourses({
          program: this.profile.enrolled_program,
          ...(school_id && { school: school_id }),
        });
        if (resp.data.length) {
          this.allCourses = resp.data;
        } else {
          this.allCourses = [];
        }
        this.addInviteSelectionsToOptions();
      } catch (err) {
        this.addInviteSelectionsToOptions();
      }
      this.areCoursesLoading = false;
    },
    handlePassType(event) {
      const { srcElement, type } = event;
      const { name, value } = srcElement;

      if (type === 'blur' && !value) {
        this.fieldTypes[name] = 'text';
      } else {
        this.fieldTypes[name] = 'password';
      }
    },

    validateFormData() {
      this.$v.$touch();
      return {
        isValid: !this.$v.$invalid,
        formData: { user: { ...this.user }, profile: { ...this.profile } },
      };
    },

    visibilityChanged(reached) {
      if (reached) {
        this.offset += 15;
        // this.fetchTags();
      }
    },

    // async fetchTags(program) {
    //   this.profile.selected_tag = null;
    //   if (!this.search) this.areTagsLoading = true;
    //   const response = await this.getTags({
    //     ...(this.search && { search: this.search }),
    //     program__id: program,
    //     limit: this.limit,
    //     offset: this.offset,
    //   });

    //   this.allTags = this.allTags.concat(response.data.data.results);
    //   this.totalTags = response.data.data.count;
    //   this.areTagsLoading = false;

    //   if (this.allTags.length > 15) {
    //     setTimeout(() => {
    //       const el = document.getElementById(`tag-${this.allTags.slice(-15)[0].id}`);

    //       if (el) {
    //         el.scrollIntoView({ behavior: 'instant', block: 'nearest' });
    //       }
    //     }, 100);
    //   }
    // },

    // debouncedSearchTag: debounce(async (loading, search, vm) => {
    //   vm.search = search;
    //   const response = await vm.getTags({
    //     search,
    //     program__id: vm.profile.enrolled_program,
    //     limit: vm.limit,
    //     offset: vm.offset,
    //   });
    //   loading(false);

    //   vm.allTags = [];
    //   vm.totalTags = 0;
    //   vm.allTags = vm.allTags.concat(response.data.data.results);
    //   vm.totalTags = response.data.data.count;
    // }, 500),

    // async fetchOptions(search, loading) {
    //   if (!this.profile.selected_tag) {
    //     this.offset = 0;
    //     this.allTags = [];
    //     this.search = search;
    //     loading(true);
    //     this.debouncedSearchTag(loading, search, this);
    //   }
    // },

    fillInOptions() {
      var usStates = new UsaStates();
      this.stateOptions = this.stateOptions.concat(
        map(usStates.states, state => ({
          value: state.name,
          text: state.name,
        })),
      );
      this.countryOptions = this.countryOptions.concat(
        map(countries, country => ({
          value: country.name,
          text: country.name,
        })),
      );
    },
    async fetchAllSchools() {
      // Only the organization dashboard renders the School select, and the
      // endpoint requires an authenticated session — skip it everywhere else
      // so public pages (accept-invite) don't fire a doomed request.
      if (this.getLoggedInUserDashboard !== DASHBOARD_TYPES.ORGANIZATION) {
        return;
      }

      this.areSchoolsLoading = true;
      try {
        const response = await this.getAllSchools();
        this.allSchools = response.data.map(school => {
          return {
            value: school.id,
            title: school.name,
          };
        });
        this.allSchools = [...this.allSchools, { value: 'other', title: 'Other' }];
      } catch (error) {
        //
      }
      this.areSchoolsLoading = false;
    },
    async uploadFile(fileType, uploadType = 'images', profileUrlField = 'resume_url', allowedType = 'image') {
      this.fileSizeExceed[fileType] = this.invalidFileType[fileType] = false;

      if (this.selectedUploadFile[fileType].size > 10 * 1024 * 1024) {
        this.fileSizeExceed[fileType] = true;
        return;
      } else if (!this.selectedUploadFile[fileType].type.includes(allowedType)) {
        this.invalidFileType[fileType] = true;
        return;
      }

      this.isUploading[fileType] = true;
      this.$emit('isUploading', this.isUploading);
      this.uploadCancelTokenSource[fileType] = axios.CancelToken.source();

      try {
        const urlResp = await this.getStudentUploadPresignedUrl({
          file_name: this.selectedUploadFile[fileType].name,
          content_type: this.selectedUploadFile[fileType].type,
          upload_type: uploadType,
        });
        await this.uploadToPresignedUrl({
          url: urlResp.upload_url,
          file: this.selectedUploadFile[fileType],
          config: {
            onUploadProgress: function(progressEvent) {
              this.uploadPercent[fileType] = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }.bind(this),
            cancelToken: this.uploadCancelTokenSource[fileType].token,
          },
        });
        if (fileType === 'avatar') this.user.avatar_url = urlResp.upload_url.split('?')[0];
        else this.profile[profileUrlField] = urlResp.upload_url.split('?')[0];
      } catch (error) {
        this.selectedUploadFile[fileType] = null;
      }

      this.uploadCancelTokenSource[fileType] = null;
      this.uploadPercent[fileType] = 0;

      this.isUploading[fileType] = false;
      this.$emit('isUploading', this.isUploading);
    },
  },

  mounted() {
    this.fillInOptions();
    this.fetchAllSchools();
    this.addInviteSelectionsToOptions();
  },
};
</script>
